import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
export const getPointsApplicationsEndpoint = {
    [pointsEndpointIds.GET_POINTS_APPLICATIONS]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: {
                    type: 'string',
                },
                states: {
                    type: 'array',
                    items: {
                        type: 'string',
                    },
                },
                page: {
                    type: 'number',
                },
                limit: {
                    type: 'number',
                },
            },
        },
    },
};
